import { render } from "./RejectApplicationList.vue?vue&type=template&id=31e4e5c2&scoped=true"
import script from "./RejectApplicationList.vue?vue&type=script&lang=js"
export * from "./RejectApplicationList.vue?vue&type=script&lang=js"

import "./RejectApplicationList.vue?vue&type=style&index=0&id=31e4e5c2&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\know_your_doctor\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e4e5c2"]])

export default __exports__